{
  "app-version": "Streamplace v{$version}",
  "download-new-update": "Descărcați noua actualizare",
  "check-for-updates": "Căutați actualizări",
  "bundled-runtype": "Bundled",
  "ota-runtype": "Over-the-Air (OTA)",
  "recovery-runtype": "Mod de recuperare",
  "modal-latest-version": "Aveți cea mai recentă versiune.",
  "modal-no-update-available": "Aveți cea mai recentă versiune de Streamplace, ura!",
  "modal-update-available-title": "Actualizare disponibilă",
  "modal-update-available-description": "O nouă versiune de Streamplace este gata de descărcare",
  "modal-update-failed": "Căutarea actualizării a eșuat. Este posibil să fie nevoie să actualizați aplicația prin {$store}.",
  "modal-update-failed-title": "Actualizare eșuată",
  "modal-update-failed-description": "Căutarea actualizării a eșuat. Este posibil să fie nevoie să actualizați aplicația prin {$store}.",
  "button-reload-app-on-update": "Aplicați actualizarea (va reîncărca aplicația)",
  "use-custom-node": "Utilizați nodul personalizat",
  "default-url": "Default: {$url}",
  "enter-custom-node-url": "Introduceți adresa URL a nodului personalizat",
  "save-button": "Salvare",
  "try-new-web": "Încercați noul web (beta)",
  "try-new-web-description": "Comutați la noua interfață web. Puteți reveni oricând din aceeași setare.",
  "try-old-app": "Folosiți interfața originală",
  "try-old-app-description": "Reveniți la interfața originală Streamplace.",
  "language-selection": "Limbă",
  "language-selection-description": "Alegeți-vă limba preferată",
  "input-search-languages": "Căutați limbi...",
  "help-translate": "Ajutați-ne să traducem Streamplace",
  "help-translate-description": "Căutăm voluntari care să ne ajute la traducerea Streamplace în mai multe limbi. Dacă sunteți interesați, vă rugăm să ne contactați pe Discord sau GitHub!",
  "currently-translating": "Traducerile sunt pe drum",
  "currently-translating-description": "Este posibil ca unele părți ale aplicației să pară incomplete. Vă mulțumim pentru răbdare!",
  "debug-recording-title": "Permiteți-i lui {$host} să înregistreze transmisiunea live pentru depanare și îmbunătățirea serviciului",
  "debug-recording-description": "Opțional",
  "manage-keys": "Gestionare chei",
  "settings-title": "Setări",
  "about": "Despre",
  "account": "Cont",
  "advanced": "Complex",
  "danmu": "Danmu",
  "developer": "Dezvoltator",
  "languages": "Limbi",
  "privacy-security": "Confidențialitate și securitate",
  "streaming": "Streaming",
  "notifications": "Notificări",
  "cancel": "Anulare",
  "create": "Creare",
  "delete": "Ștergere",
  "refresh": "Reîmprospătare",
  "sign-in": "Conectare",
  "update": "Actualizare",
  "log-out": "Deconectare",
  "optional": "opțional",
  "account-greeting": "Hei, @{$handle}.",
  "edit-profile-bluesky": "Editare profil (pe Bluesky)",
  "change-name-color": "Schimbați culoarea numelui",
  "key-management": "Gestionare chei",
  "key-manager": "Manager cheie",
  "your-stream-pubkeys": "Cheile publice ale transmisiunii dvs.",
  "no-keys": "Nicio cheie configurată",
  "pubkey-description": "Cheile publice sunt asociate cu cheile de transmisiune (utilizate în software-ul de streaming) pentru a semna și verifica transmisiunea.",
  "keys-count": "{$count ->\n   [one] {$count} cheie\n   *[other] {$count} chei\n  }",
  "recommendations": "Recomandări",
  "manage-recommendations": "Gestionați recomandările",
  "recommendations-to-others": "Recomandări pentru Alții",
  "recommendations-description": "Distribuie până la 8 streameri pe care îi recomandați spectatorilor dvs.",
  "no-recommendations-yet": "Nu au fost configurate recomandări încă",
  "add-recommendation": "Adăugare recomandare",
  "streamer-did": "DID Streamer",
  "recommendations-count": "{$count ->\n   [one] {$count} recomandare\n   *[other] {$count} (de) recomandări\n  }",
  "webhooks": "Webhook-uri",
  "webhook-integrations": "Integrari Webhook",
  "webhook-integrations-description": "Conectați servicii externe pentru a primi actualizări în timp real despre transmisiunile dvs.",
  "create-webhook": "Creare Webhook",
  "edit-webhook": "Editare Webhook",
  "delete-webhook": "Ștergere Webhook",
  "no-webhooks-yet": "Nu sunt încă configurate webhook-uri",
  "failed-load-webhooks": "Nu s-au putut încărca webhook-urile",
  "webhook-will-no-longer-receive-events": "Acest webhook nu va mai primi evenimente",
  "create-first-webhook-description": "Creați-vă primul webhook pentru a începe să primiți evenimente de transmisiune",
  "example-captain-hook": "Captain Hook",
  "webhooks-count": "{$count ->\n   [one] {$count} webhook\n   *[other] {$count} (de) webhook-uri\n  }",
  "activates-on": "Se activează la:",
  "events": "Evenimente",
  "events-livestream": "Evenimente în transmisiuni",
  "events-chat": "Evenimente de conversașie",
  "untitled-webhook": "Webhook fără titlu",
  "inactive": "Inactiv",
  "active": "Activ",
  "multistream": "Multi-transmisiune",
  "multistream-targets": "Ținte multi-transmisiune",
  "multistream-description": "Distribuie automat transmisiunile tale live Streamplace către alte servicii de streaming precum Twitch sau YouTube.",
  "create-multistream-target": "Creare țintă multi-transmisiune",
  "untitled-multistream-target": "Țintă fără titlu",
  "failed-load-multistream-targets": "Nu s-au putut încărca țintele multi-transmisiune. Vă rugăm să încercați din nou.",
  "failed-toggle-multistream-target": "Nu s-a putut comuta ținta multi-transmisiune. Vă rugăm să încercați din nou.",
  "failed-delete-multistream-target": "Ștergerea țintei multi-transmisiune nu a reușit. Încercați din nou.",
  "no-multistream-targets-yet": "Nu există încă ținte!",
  "multistream-targets-count": "{$count ->\n   [one] {$count} țintă\n   *[other] {$count} (de) ținte\n  }",
  "multistream-delete-target-confirmation": "Sunteți sigur că vreți să ștergeți „{$target}”?",
  "this-action-cannot-be-undone": "Această acțiune nu poate fi anulată.",
  "rtmp-target-name": "Țintă RTMP",
  "rtmp-target-url": "URL RTMP",
  "rtmp-target-name-placeholder": "Ținta mea transmisiune",
  "multistream-create-target": "Creare țintă",
  "multistream-edit-target": "Editare țintă",
  "created": "creată",
  "status": "stare",
  "debug-recording": "Depanare înregistrare",
  "danmu-enabled": "Activare Danmu",
  "danmu-enabled-description": "Afișați mesajele din chatul live ca comentarii plutitoare pe ecran",
  "danmu-opacity": "Opacitate",
  "danmu-speed": "Viteză",
  "danmu-lane-count": "Număr de benzi",
  "danmu-max-messages": "Mesaje maxime",
  "app-version-description": "Nu sunt disponibile actualizări în acest moment",
  "confirm-delete": "Sigur vreți să ștergeți asta?",
  "action-cannot-be-undone": "Această acțiune nu poate fi anulată",
  "name-optional": "Nume (opțional)",
  "deleting": "Se șterge...",
  "saving": "Se salvează...",
  "go-to-dashboard": "Mergeți la tabloul de bord",
  "need-setup-live-dashboard": "Trebuie să configurați mai întâi transmisiunile? Vizitați tabloul de bord al transmisiunilor",
  "no-languages-found": "Nu s-au găsit limbi",
  "branding": "Branding",
  "branding-admin": "Administrarea brandingului",
  "branding-admin-description": "Personalizați-vă instanța Streamplace. Rețineți că propagarea setărilor poate dura câteva ore.",
  "branding-login-required": "Vă rugăm să vă conectați pentru a gestiona brandingul",
  "branding-configuration": "Configurare",
  "branding-text-settings": "Setări text",
  "branding-colors": "Culori",
  "branding-legal-links": "Link-uri legale",
  "branding-images": "Imagini",
  "branding-broadcaster-did": "DID radiodifuzor",
  "branding-broadcaster-did-description": "Lăsați gol pentru a utiliza valorile implicite ale serverului",
  "branding-site-title": "Titlul site-ului",
  "branding-site-title-placeholder": "Introduceți un nou titlu de site",
  "branding-site-description": "Descrierea site-ului",
  "branding-site-description-placeholder": "Introduceți descrierea site-ului",
  "branding-default-streamer": "Streamer implicit",
  "branding-default-streamer-none": "Nimic",
  "branding-default-streamer-placeholder": "did:plc:...",
  "branding-clear-default-streamer": "Ștergeți Streamerul implicit",
  "branding-primary-color": "Culoare primară",
  "branding-primary-color-placeholder": "#6366f1",
  "branding-accent-color": "Culoare de accent",
  "branding-accent-color-placeholder": "#8b5cf6",
  "branding-main-logo": "Logo principal",
  "branding-main-logo-description": "SVG, PNG, or JPEG (max 500KB)",
  "branding-favicon": "Favicon",
  "branding-favicon-description": "SVG, PNG, sau ICO (maxim 100KB)",
  "branding-sidebar-bg": "Imagine de fundal din bara laterală",
  "branding-sidebar-bg-description": "SVG, PNG sau JPEG (maxim 500kb) - apare aliniat la partea de jos a barei laterale, pe lățime completă. Încărcați o imagine cu opacitate pentru cele mai bune rezultate, deoarece în prezent nu există o opțiune separată de opacitate.",
  "branding-current": "Current: {$value}",
  "branding-dimensions": "{$height} x {$width}",
  "branding-upload-logo": "Încărcare logo",
  "branding-delete-logo": "Ștergere logo",
  "branding-upload-favicon": "Încărcare Favicon",
  "branding-delete-favicon": "Ștergere Favicon",
  "branding-upload-background": "Încărcare imagine de fundal",
  "branding-delete-background": "Ștergere imagine de fundal",
  "branding-web-only": "Încărcarea imaginilor este disponibilă doar pe web.",
  "refresh-branding": "Actualizați elementele de branding",
  "branding-add-legal-link": "Adăugați link legal",
  "branding-edit-legal-link": "Editați linkul legal",
  "branding-legal-link-text-placeholder": "Textul linkului (de exemplu, Politica de confidențialitate)",
  "branding-legal-link-url-placeholder": "Adresa URL (de ex., https://example.com/privacy)",
  "add": "Adăugare",
  "edit": "Editare",
  "branding-not-authenticated": "Vă rugăm să vă conectați mai întâi",
  "branding-empty-value": "Vă rugăm să introduceți o valoare",
  "branding-update-success": "{$key} a fost actualizat cu succes",
  "branding-upload-success": "{$key} a fost încărcat cu succes",
  "branding-delete-success": "{$key} a fost șters cu succes",
  "branding-upload-failed": "Încărcare eșuată",
  "branding-delete-failed": "Ștergere eșuată",
  "branding-not-available": "Încărcarea de fișiere este disponibilă doar pe web.",
  "node-legal-documents": "Documente specifice radiodifuzorului",
  "badges": "Insigne",
  "badges-cosmetic-section": "Insigne cosmetice",
  "badges-empty-state": "Nu ți-a fost acordată nicio insignă încă.",
  "badges-failed-load": "Nu s-au putut încărca insignele",
  "badges-failed-update": "Nu s-a putut actualiza selecția de insigne",
  "badges-issued-by": "Acordată de {$issuer}",
  "badges-streamer-section": "Insigne de la streameri",
  "issue-badges": "Emitere insigne",
  "issue-badges-back-to-definitions": "Definiții insigne",
  "issue-badges-badge-name": "Numele insignei",
  "issue-badges-badge-name-placeholder": "ex. VIP, Susținător",
  "issue-badges-badge-type": "Tipul insignei",
  "issue-badges-choose-image": "Alegeți imaginea",
  "issue-badges-create-definition": "Creare definiție insignă",
  "issue-badges-create-definition-description": "Definiți un nou tip de insignă care poate fi acordată spectatorilor",
  "issue-badges-create-definition-subtitle": "Definiți un nou tip de insignă",
  "issue-badges-definition-created": "Definiție insignă creată",
  "issue-badges-description-optional": "Descriere (opțional)",
  "issue-badges-description-placeholder": "Descriere opțională pentru această insignă",
  "issue-badges-failed-create": "Nu s-a putut crea definiția insignei",
  "issue-badges-failed-issue": "Nu s-a putut emite insigna",
  "issue-badges-failed-load": "Nu s-au putut încărca definițiile insignelor",
  "issue-badges-image-optional": "Imagine (opțional)",
  "issue-badges-image-too-large": "Imaginea trebuie să fie mai mică de 256KB",
  "issue-badges-image-web-only": "Încărcarea imaginilor este disponibilă doar pe web",
  "issue-badges-issue-badge": "Emite insignă",
  "issue-badges-issue-badge-description": "Emite insigna „{$name}\" unui spectator prin DID-ul său",
  "issue-badges-issued": "Insignă emisă",
  "issue-badges-issued-to": "Emisă pentru {$did}",
  "issue-badges-manage-description": "Creați definiții de insigne și emiteți-le spectatorilor",
  "issue-badges-recipient-did": "DID destinatar",
  "issue-badges-recipient-did-placeholder": "did:plc:...",
  "issue-badges-tap-to-issue": "Atingeți pentru a emite",
  "issue-badges-your-definitions": "Definițiile dvs. de insigne"
}
